"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledText = exports.StyledBanner = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const StyledBanner = exports.StyledBanner = _styledComponents.default.div.withConfig({
  displayName: "SessionBannerstyle__StyledBanner",
  componentId: "sc-933t01-0"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;gap:", ";button{border:1px solid ", ";white-space:nowrap;margin-right:", ";}svg{width:16px;height:18px;}}"], _uiKit.theme.spacing.BASE_2, _uiKit.theme.colours.NEUTRALS_4, _uiKit.theme.spacing.BASE_1);
const StyledText = exports.StyledText = _styledComponents.default.span.withConfig({
  displayName: "SessionBannerstyle__StyledText",
  componentId: "sc-933t01-1"
})(["text-align:", ";}"], _ref => {
  let {
    isMobile
  } = _ref;
  return isMobile ? 'left' : 'center';
});